<template>
  <div class="mt-12 f-col children:skeleton items-center pb-10 space-y-4 thenorthface:!mt-10">
    <div style="width: 10.75rem; height: 1rem" />
    <div style="width: 18.75rem; height: 0.5rem" />
    <div style="width: 18.75rem; height: 3.5rem" />
  </div>
</template>
